var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-picker" }, [
    _c("div", { staticClass: "header" }, [
      _vm._v(_vm._s(_vm.$t("tables.filter"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-wrapper" },
      [
        _c("a-input-search", {
          attrs: { placeholder: _vm.$t("message.inputSearchText") },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "list-item",
        on: {
          click: function ($event) {
            return _vm.changeCalendar("my")
          },
        },
      },
      [_vm._v(_vm._s(_vm.$t("calendar.myEvents")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "list-item",
        on: {
          click: function ($event) {
            return _vm.changeCalendar("everyone")
          },
        },
      },
      [_vm._v(_vm._s(_vm.$t("calendar.everyoneEvents")))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "group-title" }, [
      _vm._v(_vm._s(_vm.$t("calendar.agents"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-items" },
      _vm._l(_vm.getFilteredUsers(), function (user) {
        return _c(
          "div",
          {
            staticClass: "list-item",
            on: {
              click: function ($event) {
                return _vm.changeCalendar(user._id)
              },
            },
          },
          [
            _c("AgentAvatar", {
              attrs: {
                size: 25,
                userID: user._id,
                "font-size": 15,
                "single-char": "",
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(user.name))]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }